import styled from "styled-components";

import { Divider } from "CrossFeatureComponents/MemberToolbar/components/shared";

import BottomSection from "./BottomSection";
import Data from "./Data";

const RightSection = () => {
  return (
    <Wrapper>
      <Data />
      <Divider marginX={-5} />
      <BottomSection />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
`;

export default RightSection;
